import { CurrencyCode } from './CurrencyCode';
import { CurrencySymbol } from './CurrencySymbol';

export class CurrencySymbolAdapter {
    private static readonly currencyCodeToSymbolMap: Readonly<Record<CurrencyCode, CurrencySymbol>> = {
        [CurrencyCode.usd]: CurrencySymbol.usd,
        [CurrencyCode.cad]: CurrencySymbol.cad,
        [CurrencyCode.gbp]: CurrencySymbol.gbp,
        [CurrencyCode.eur]: CurrencySymbol.eur,
        [CurrencyCode.jpy]: CurrencySymbol.jpy,
        [CurrencyCode.brl]: CurrencySymbol.brl,
        [CurrencyCode.inr]: CurrencySymbol.inr,
        [CurrencyCode.aud]: CurrencySymbol.aud,
    };

    public static fromCurrencyCode(currencyCode: CurrencyCode): CurrencySymbol {
        if (currencyCode in this.currencyCodeToSymbolMap) {
            return this.currencyCodeToSymbolMap[currencyCode];
        }

        // Default to USD if not found
        return CurrencySymbol.usd;
    }
}
